var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUplead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "225.000000pt",
    height: "225.000000pt",
    viewBox: "0 0 225.000000 225.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,225.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M970 1392 c0 -336 -6 -377 -64 -435 -75 -75 -219 -76 -297 -2 -62 58 -64 69 -67 414 l-3 314 -155 -154 -154 -154 127 -5 128 -5 -52 -29 -53 -29 0 -107 c0 -236 53 -342 206 -412 42 -20 65 -23 169 -23 108 0 125 3 175 26 80 37 125 81 162 157 l33 67 3 337 3 338 -80 0 -81 0 0 -298z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197 1443 c-4 -3 -7 -33 -7 -65 0 -55 1 -58 24 -58 55 0 56 -11 56 -427 l0 -383 75 0 75 0 0 177 0 177 28 -31 c45 -49 88 -66 177 -71 65 -3 91 0 137 18 69 26 136 87 175 161 26 50 28 63 28 164 0 101 -2 114 -28 163 -35 67 -90 122 -153 153 -42 21 -63 24 -149 24 -91 0 -104 -2 -147 -28 -26 -15 -54 -37 -62 -49 -9 -12 -17 -20 -18 -17 -2 2 -10 18 -18 34 -9 17 -31 38 -50 47 -34 18 -130 25 -143 11z m540 -169 c135 -107 97 -327 -65 -369 -89 -24 -173 7 -227 84 -27 38 -30 51 -30 116 0 65 3 78 30 116 45 64 104 91 187 87 56 -3 73 -8 105 -34z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUplead);
export default __webpack_public_path__ + "static/media/uplead.f9583380987a447498548c3eebab63fc.svg";
export { ForwardRef as ReactComponent };